(function () {
    'use strict';

    angular
        .module('app')
        .controller('SubjectsController', SubjectsController);

    SubjectsController.$inject = ['$state',];

    function SubjectsController($state) {
        // var vm = this;


        activate();

        function activate() {
            // Run on load
            if ($state && $state.current && $state.current.name === 'subjects') {
                $state.go('subjects.list');
            }
        }
    }
})();